import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  sizes: [],
};

export const createSize = createAsyncThunk(
  "createSize/size",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("sizes", data);
      enqueueSnackbar("Size is added successfully");
      navigate(PATH_DASHBOARD.entries.sizes.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchSize = createAsyncThunk(
  "fetchSize/size",
  async (
    { enqueueSnackbar, category_id, page = 0, limit = 1000 },
    thunkApi
  ) => {
    try {
      let response;
      if (category_id) {
        response = await axiosInstance.get(
          `sizes?orderBy=name&category_id=${category_id}&page=${
            page + 1
          }&limit=${limit}`
        );
      } else {
        response = await axiosInstance.get(
          `sizes?orderBy=name&page=${page + 1}&limit=${limit}`
        );
      }

      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateSize = createAsyncThunk(
  "updateSize/size",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`sizes/${slug}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteSize = createAsyncThunk(
  "deleteSize/size",
  async ({ id, enqueueSnackbar, limit, page }, thunkApi) => {
    try {
      await axiosInstance.delete(`sizes/${id}`);
      thunkApi.dispatch(fetchSize({ limit, page, enqueueSnackbar }));
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const sizeSlice = createSlice({
  name: "size",
  initialState,
  extraReducers: (builder) => {
    // TODO: create size
    builder.addCase(createSize.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createSize.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createSize.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch size
    builder.addCase(fetchSize.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSize.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.sizes = action.payload;
    });

    builder.addCase(fetchSize.rejected, (state, action) => {
      state.fetchLoading = false;
      // action.payload.enqueueSnackbar(action.payload.error.message, {
      //   variant: "error",
      // });
    });

    // ==========================

    // TODO: update size
    builder.addCase(updateSize.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateSize.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Size is updated successfully");
      state.sizes.data = state.sizes.data.map((size) =>
        size.slug === action.payload.slug ? action.payload.data : size
      );
      action.payload.setOpenEdit(false);
    });

    builder.addCase(updateSize.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete size
    builder.addCase(deleteSize.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteSize.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.sizes.data = state.sizes.data.filter(
      //   (size) => size.id !== action.payload.id
      // );
      action.payload.enqueueSnackbar("Size is deleted successfully");
    });

    builder.addCase(deleteSize.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default sizeSlice.reducer;
